module.exports = __webpack_public_path__ + "img/visual-06.4cf6ed2c.png";